import { schema } from 'normalizr';

// Organizations
export const OrgNormalizer = new schema.Entity('organizations');

// Locations
export const LocationNormalizer = new schema.Entity('locations');

// Users
export const UserNormalizer = new schema.Entity('users', {
  organization: OrgNormalizer,
});

export const UserAuthNormalizer = new schema.Object({
  user: UserNormalizer,
});

// Transactions
export const TransactionNormalizer = new schema.Entity('transactions', {
  location: LocationNormalizer,
  user: UserNormalizer,
  toOrganization: OrgNormalizer,
});

export const DepartmentNormalizer = new schema.Entity('departments');
